import { InstallmentConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case InstallmentConstant.SET_INSTALLMENTS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
